import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://react-my-burger-936e7-default-rtdb.firebaseio.com/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-orders.js